import { Box, Button, ButtonSize, Heading, Icon, IconSize, ModalBody, ModalHeaderStyled } from '@bechtel/gds';
import { ListType, OperatorType } from '@bechtel/sr-types';
import { mergeWith } from 'lodash';
import { FC, useMemo, useState } from 'react';
import { useTheme } from 'styled-components';
import { SelectGrid, usePickListFilterContext } from '~/components';
import { MultiLingualText } from '~/components/atoms';
import { DrawerFooterButtonStyled, ModalCloseStyled, ModalFooterStyled, ModalStyled } from './styled';
import { mergeArrays } from './utils';

interface SelectGridModalProps {
  listType: ListType;
  listName: string;
  title: string;
  close: () => void;
  selectItem: (data) => void;
  defaultFilterValue?: any;
}

export const SelectGridModal: FC<SelectGridModalProps> = ({
  listName,
  title,
  close,
  selectItem,
  listType,
  defaultFilterValue,
}) => {
  const theme = useTheme();
  const [selectedItem, setSelectedItem] = useState(null);
  const pickListFilter = usePickListFilterContext();

  const handleClick = (data) => {
    setSelectedItem(data);
  };
  const handleDoubleClick = (data) => {
    selectItem(data);
  };

  const pickListName = listType === ListType.CONTROLLED || listType === ListType.NONE ? listName : 'PICK_LIST.NAME';

  const defaultFilter = useMemo(() => {
    // filter we can pass to apply for picklist
    if (pickListFilter && pickListFilter?.pickListName === pickListName) {
      return mergeWith(pickListFilter.filter, defaultFilterValue, mergeArrays);
    } else if (!(listType === ListType.CONTROLLED || listType === ListType.NONE)) {
      const filterVal = {
        and: [
          {
            field: 'NAME',
            operator: OperatorType.EQUAL,
            value: listName,
          },
        ],
      };
      return mergeWith(filterVal, defaultFilterValue, mergeArrays);
    } else {
      return mergeWith(undefined, defaultFilterValue, mergeArrays);
    }
  }, [pickListFilter, pickListName, listType, defaultFilterValue, listName]);

  return (
    <ModalStyled visible>
      <ModalHeaderStyled style={{ paddingTop: theme.spacings[500] }}>
        {title && (
          <Heading size="500" weight="500">
            <MultiLingualText>Find</MultiLingualText>
          </Heading>
        )}

        <ModalCloseStyled>
          <Button size={ButtonSize.LARGE} onClick={close} style={{ background: 'transparent', boxShadow: 'none' }}>
            <Icon icon="xmark" iconStyle="regular" size={IconSize.LARGE} />
          </Button>
        </ModalCloseStyled>
      </ModalHeaderStyled>
      {/* @ts-ignore adjust in GDS component to take child as prop  */}
      <ModalBody>
        <Box flexGrow={{ sm: 1 }} p={{ sm: '400' }} pb={{ sm: '200' }}>
          <SelectGrid
            name={pickListName}
            onClick={handleClick}
            onDoubleClick={handleDoubleClick}
            defaultFilter={defaultFilter}
            close={close}
          ></SelectGrid>
        </Box>
      </ModalBody>
      <ModalFooterStyled>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '300' }}>
            <DrawerFooterButtonStyled
              onClick={() => {
                selectItem(selectedItem);
              }}
              disabled={selectedItem == null}
            >
              <MultiLingualText>OK</MultiLingualText>
            </DrawerFooterButtonStyled>
          </Box>
        </Box>
      </ModalFooterStyled>
    </ModalStyled>
  );
};
